import React, { useContext, useEffect, useRef, useState } from 'react';
import { PlusOutlined, CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Popconfirm, Row, Select, Space, Table, Typography } from 'antd';
import EventForm from './EventForm';
const EditableContext = React.createContext(null);

const { Text, Title, Paragraph } = Typography;

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};



const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};



const TableSystemHooks = ({ disabled, setDisabled, formData, form }) => {
    const [dataSource, setDataSource] = useState([]);
    const [count, setCount] = useState(1);



    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const defaultColumns = [
        {
            title: "Entity Name",
            dataIndex: "entity",
        },
        {
            title: "Action Name",
            dataIndex: "action",
        },
        {
            title: '',
            dataIndex: 'actions',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: '#15CCAE',
                                color: 'white',
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                    >
                        <CloseOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder" }} />
                    </Popconfirm>
                ) : null,
        },
    ];


    const handleAdd = async (formValues) => {
        console.log(formData);
        try {
            formValues = await form.validateFields(['grouping', 'entity', 'action']);
            if (formValues === null) {
                return;
            } else {
                // setDisabled(false);
                const newData = {
                    key: count,
                    entity: `Entity ${count}`,
                    action: `Action ${count}`,
                    actions: ""
                };
                setDataSource([...dataSource, newData]);
                setCount(count + 1);
            }
        } catch (errorInfo) {
            console.log(formValues);
            console.error('Form validation error:', errorInfo);
        }
    };


    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            <EventForm disabled={disabled} handleAdd={handleAdd} />
            <Table
                // components={components}
                // rowClassName={() => 'editable-row'}
                bordered
                dataSource={dataSource}
                columns={columns}
            />
        </div>
    );
};
export default TableSystemHooks;


